const offerManage = () => import('./manage');
const offerViewList = () => import('./viewList');
const offerProfessor = () => import('./professor');
const offerProject = () => import('./project');
const offerProjectDetail = () => import('./projectDetail');

const offerRouter = [
  {
    path: '/offer/manage', name: 'offerManage', component: offerManage, meta: { c: 'offer', a: 'manage' }
  },
  {
    path: '/offer/viewList', name: 'offerViewList', component: offerViewList, meta: { c: 'offer', a: 'viewList' }
  },
  {
    path: '/offer/professor', name: 'offerProfessor', component: offerProfessor, meta: { c: 'offer', a: 'professor' }
  },
  {
    path: '/offer/project', name: 'offerProject', component: offerProject, meta: { c: 'offer', a: 'project' }
  },
  {
    path: '/offer/projectDetail/:id', name: 'offerProjectDetail', component: offerProjectDetail, meta: { c: 'offer', a: 'projectDetail' }
  },
];

export default offerRouter;

